import { PlanData } from "../models/PlanBase";
import {
  getSubscriptionState,
  SubscriptionParamsForState,
} from "./getSubscriptionState";
import { Entitlement } from "./subscriptionState";

export type SubscriptionWithPlan = SubscriptionParamsForState & {
  plan: PlanData;
};

/**
 * Is there a valid subscription (in good standing), with a plan which meets the
 * condition?
 */
export function hasValidPlanWith(
  subscriptions: SubscriptionWithPlan[],
  cond: (props: { plan: PlanData }) => boolean,
): boolean {
  const entitledSubscriptions = subscriptions.filter(
    (subscription) =>
      getSubscriptionState(subscription).entitlement === Entitlement.Entitled,
  );

  return entitledSubscriptions.some((s) =>
    cond({
      plan: s.plan,
    }),
  );
}
